import script from "./PlaylistPlay.vue?vue&type=script&setup=true&lang=js"
export * from "./PlaylistPlay.vue?vue&type=script&setup=true&lang=js"

import "./PlaylistPlay.vue?vue&type=style&index=0&id=68b8eeaf&lang=css"

const __exports__ = script;

export default __exports__